/**
 * Script Name: Submenu Toggle Script
 * Version: 1.0.0
 * Description: Handles submenu toggling functionality in the header.
 * Author: Wubbe
 * Date: December 14, 2023
 */

import './header-1-0';

//show or hidden block submenu
const submenu = document.querySelectorAll(".header .menu-item-has-children");
// const overlay = document.querySelector(".header__overlay");

submenu.forEach((menuItem) => {
    menuItem.addEventListener("click",(e)=>{
        const clickedSubmenu = e.currentTarget;
        if (!clickedSubmenu.classList.contains("is-active")) {
            submenu.forEach(sub => sub.classList.remove("is-active"));
            clickedSubmenu.classList.add("is-active");
            // Toggle overlay or any related actions if needed
        } else {
            clickedSubmenu.classList.remove("is-active");
            // Toggle overlay or any related actions if needed
        }
    });
    
});
document.addEventListener('click', function(e) {
    const clickedMenuItem = e.target.closest(".menu-item-has-children");
    if (!clickedMenuItem) {
        submenu.forEach(sub => sub.classList.remove("is-active"));
    }
});